/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Precheck_IgnoreInputs */

const en_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore`)
};

const fr_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer`)
};

const de_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorieren`)
};

const it_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorare`)
};

const ru_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игнорировать`)
};

const es_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar`)
};

const zh_cn2_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忽略`)
};

const ja_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無視する`)
};

const hi_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनदेखा करना`)
};

const pt_pt2_dialogue_list_export_precheck_ignore = /** @type {(inputs: Dialogue_List_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar`)
};

/**
* | output |
* | --- |
* | "Ignore" |
*
* @param {Dialogue_List_Export_Precheck_IgnoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_precheck_ignore = /** @type {((inputs?: Dialogue_List_Export_Precheck_IgnoreInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Precheck_IgnoreInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_precheck_ignore(inputs)
	if (locale === "de") return de_dialogue_list_export_precheck_ignore(inputs)
	if (locale === "it") return it_dialogue_list_export_precheck_ignore(inputs)
	if (locale === "ru") return ru_dialogue_list_export_precheck_ignore(inputs)
	if (locale === "es") return es_dialogue_list_export_precheck_ignore(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_precheck_ignore(inputs)
	if (locale === "ja") return ja_dialogue_list_export_precheck_ignore(inputs)
	if (locale === "hi") return hi_dialogue_list_export_precheck_ignore(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_precheck_ignore(inputs)
	return en_dialogue_list_export_precheck_ignore(inputs)
});